<template>
  <div class="parameter-merge-container">
    <Card>
      <p slot="title">参数清理</p>

      <div class="search-con">
        <Input
          v-model="searchParams.keyword"
          placeholder="请输入含义搜索"
          style="width: 300px; margin-right: 10px"
          clearable
          @on-enter="handleSearch"
        >
          <span slot="prepend">搜索</span>
        </Input>
        <Button type="primary" @click="handleSearch">搜索</Button>
        <Button type="success" @click="handleAdd" style="margin-left: 10px">新增参数组</Button>
        <Button type="info" @click="openIterateModal" style="margin-left: 10px">数据参数更迭</Button>
      </div>

      <div style="margin-top: 20px">
        <Table
          :columns="columns"
          :data="tableData"
          :loading="loading"
          border
          stripe
        >
          <template slot-scope="{ row }" slot="type">
            <Tag :color="typeColorMap[row.type]">
              {{ typeNameMap[row.type] || row.type }}
            </Tag>
          </template>

          

          <template slot-scope="{ row }" slot="action">
            <Button type="primary" size="small" @click="handleEdit(row)">编辑</Button>
            <Button type="warning" size="small" style="margin-left: 6px" @click="openChildSelectModal(row)">子类</Button>
            <Button type="error" size="small" style="margin-left: 6px" @click="handleDelete(row)">删除</Button>
          </template>
        </Table>

        <div style="margin-top: 20px; text-align: right">
          <Page
            :total="total"
            :current="pageParams.page"
            :page-size="pageParams.limit"
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
            show-sizer
            show-total
          />
        </div>
      </div>
    </Card>

    <!-- 新增/编辑弹窗 -->
    <Modal
      v-model="modalVisible"
      :title="modalTitle"
      width="500px"
      @on-ok="handleSubmit"
      @on-cancel="modalVisible = false"
    >
      <Form ref="mergeForm" :model="formData" :rules="formRules">
        <FormItem label="表名" prop="table">
          <Input v-model="formData.table" placeholder="如 job_info" />
        </FormItem>
        <FormItem label="字段" prop="field">
          <Input v-model="formData.field" placeholder="如 Jsalary" />
        </FormItem>
        <FormItem label="新值" prop="value">
          <Input v-model="formData.value" placeholder="合并后的新参数值" />
        </FormItem>
        <FormItem label="含义" prop="meaning">
          <Input v-model="formData.meaning" placeholder="如 1000-2000元" />
        </FormItem>
        <FormItem label="类型" prop="type">
          <Select v-model="formData.type" placeholder="请选择类型">
            <Option value="基础">基础</Option>
            <Option value="统计">统计</Option>
            <Option value="筛选">筛选</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modalVisible = false">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>

    <!-- 子类参数选择弹窗 -->
    <Modal
      v-model="childSelectModalVisible"
      title="选择子类参数"
      width="900px"
      :footer-hide="true"
    >
      <div class="child-select-bar">
        <span style="line-height: 32px; margin-right: 12px; color: #666">
          当前组：<b>{{ currentGroupTable }}.{{ currentGroupField }}</b>
        </span>
        <Input
          v-model="childSearchKeyword"
          placeholder="搜索含义"
          style="width: 240px; margin-right: 10px"
          clearable
          @on-enter="searchChildParams"
        >
          <span slot="prepend">搜索</span>
        </Input>
        <Button type="primary" @click="searchChildParams">搜索</Button>
        <Button type="success" @click="saveChildSelection" style="margin-left: 10px" :loading="childSaving">保存选择</Button>
      </div>
      <div style="margin-top: 16px">
        <Table
          ref="childTable"
          :columns="childColumns"
          :data="childTableData"
          :loading="childLoading"
          border
          stripe
          @on-selection-change="handleChildSelectionChange"
        >
        </Table>
        <div style="margin-top: 16px; text-align: right">
          <Page
            :total="childTotal"
            :current="childPageParams.page"
            :page-size="childPageParams.limit"
            @on-change="handleChildPageChange"
            @on-page-size-change="handleChildPageSizeChange"
            show-sizer
            show-total
          />
        </div>
      </div>
    </Modal>

    <!-- 已选子类列表弹窗 -->
    <Modal
      :value="childListModalVisible"
      title="已选子类参数"
      width="800px"
      @on-cancel="childListModalVisible = false"
    >
      <div style="margin-bottom: 12px">
        <Button type="error" size="small" @click="batchDeleteChildren" :disabled="childListSelection.length === 0">批量删除</Button>
        <Button type="warning" size="small" @click="clearAllChildren" style="margin-left: 10px">清空全部</Button>
        <Button @click="childListModalVisible = false" style="float: right">关闭</Button>
      </div>
      <Table
        ref="childListTable"
        :columns="childListColumns"
        :data="childListData"
        :loading="childListLoading"
        border
        stripe
        @on-selection-change="handleChildListSelectionChange"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="error" size="small" @click="removeSingleChild(row)">移除</Button>
        </template>
      </Table>
    </Modal>

    <!-- 数据参数更迭弹窗 -->
    <Modal
      v-model="iterateModalVisible"
      title="数据参数更迭"
      width="500px"
      @on-ok="handleIterate"
      @on-cancel="iterateModalVisible = false"
    >
      <Form ref="iterateForm" :model="iterateFormData" :rules="iterateFormRules">
        <FormItem label="参数组" prop="group_id">
          <Select v-model="iterateFormData.group_id" placeholder="请选择参数组">
            <Option v-for="item in allGroups" :key="item.id" :value="item.id">
              {{ item.table }}.{{ item.field }} → {{ item.meaning }}（值: {{ item.value }}）
            </Option>
          </Select>
        </FormItem>
        <Alert type="info" show-icon style="margin-top: 8px">
          将 <b>{{ selectedGroupField }}</b> 字段中所有子类旧值替换为新值
        </Alert>
      </Form>
      <div slot="footer">
        <Button @click="iterateModalVisible = false">取消</Button>
        <Button type="primary" @click="handleIterate">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getParameterMergeList, saveParameterMerge, deleteParameterMerge, iterateParameterMerge } from '@/api/system/parameter_merge'
import { getsysparameterList } from '@/api/system/sys_parameter'

export default {
  name: 'ParameterMerge',
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,
      allGroups: [],

      searchParams: { keyword: '' },
      pageParams: { page: 1, limit: 10 },

      typeNameMap: { '基础': '基础', '统计': '统计', '筛选': '筛选' },
      typeColorMap: { '基础': 'green', '统计': 'blue', '筛选': 'orange' },

      // 新增/编辑
      modalVisible: false,
      modalTitle: '',
      formData: { id: null, table: '', field: '', value: '', meaning: '', type: '', remark: '' },
      formRules: {
        table: [
          { required: true, message: '请输入表名', trigger: 'blur' },
          { max: 100, message: '长度不能超过 100 个字符', trigger: 'blur' }
        ],
        field: [
          { required: true, message: '请输入字段', trigger: 'blur' },
          { max: 100, message: '长度不能超过 100 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入新值', trigger: 'blur' },
          { max: 100, message: '长度不能超过 100 个字符', trigger: 'blur' }
        ],
        meaning: [
          { required: true, message: '请输入含义', trigger: 'blur' },
          { max: 100, message: '长度不能超过 100 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        remark: [
          { max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' }
        ]
      },

      // 子类选择弹窗
      childSelectModalVisible: false,
      childSelectGroupId: null,
      currentGroupTable: '',
      currentGroupField: '',
      childSearchKeyword: '',
      childTableData: [],
      childTotal: 0,
      childLoading: false,
      childSaving: false,
      childPageParams: { page: 1, limit: 10 },
      childSelection: [],
      currentChildIds: [],
      childColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: 'ID', key: 'id', width: 70 },
        { title: '值', key: 'value', width: 100 },
        { title: '含义', key: 'meaning', width: 200 },
        { title: '备注', key: 'remark', width: 200 }
      ],

      // 已选子类列表弹窗
      childListModalVisible: false,
      childListGroupId: null,
      childListData: [],
      childListLoading: false,
      childListSelection: [],
      childListColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: 'ID', key: 'id', width: 70 },
        { title: '值', key: 'value', width: 100 },
        { title: '含义', key: 'meaning', width: 200 },
        { title: '备注', key: 'remark', width: 200 },
        { title: '操作', slot: 'action', width: 80, fixed: 'right' }
      ],

      // 迭代
      iterateModalVisible: false,
      iterateFormData: { group_id: null },
      iterateFormRules: {
        group_id: [{ required: true, message: '请选择参数组', trigger: 'change', type: 'number' }]
      },

      columns: [
        { title: 'ID', key: 'id', width: 70 },
        { title: '表名', key: 'table', width: 120 },
        { title: '字段', key: 'field', width: 120 },
        { title: '新值', key: 'value', width: 90 },
        { title: '含义', key: 'meaning', width: 150 },
        { title: '类型', slot: 'type', width: 90 },
        { title: '子类', width: 80,
          render: (h, { row }) => {
            const count = this.getChildCount(row)
            return h('Tag', {
              props: { color: count > 0 ? 'blue' : 'default' },
              style: { cursor: 'pointer' },
              nativeOn: { click: () => this.openChildListModal(row) }
            }, String(count))
          }
        },
        { title: '操作', slot: 'action', width: 240, fixed: 'right' }
      ]
    }
  },

  computed: {
    selectedGroupField () {
      if (!this.iterateFormData.group_id) return ''
      const g = this.allGroups.find(g => g.id === this.iterateFormData.group_id)
      return g ? `${g.table}.${g.field}` : ''
    }
  },

  mounted () {
    this.getList()
    this.loadAllGroups()
  },

  methods: {
    getChildIdsArray (row) {
      if (!row.child_ids) return []
      const raw = typeof row.child_ids === 'string' ? row.child_ids : String(row.child_ids)
      return raw.split(',').filter(Boolean).map(Number)
    },

    getChildCount (row) {
      return this.getChildIdsArray(row).length
    },

    async getList () {
      this.loading = true
      try {
        const res = await getParameterMergeList({
          page: this.pageParams.page,
          limit: this.pageParams.limit,
          keyword: this.searchParams.keyword
        })
        if (res.data.code === 0) {
          this.tableData = res.data.data || []
          this.total = res.data.count || 0
        } else {
          this.$Message.error(res.data.msg || '获取列表失败')
        }
      } catch (error) {
        this.$Message.error('获取列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    async loadAllGroups () {
      try {
        const res = await getParameterMergeList({ page: 1, limit: 9999, keyword: '' })
        if (res.data.code === 0) {
          this.allGroups = res.data.data || []
        }
      } catch (error) {
        console.error('加载全部参数组失败', error)
      }
    },

    handleSearch () { this.pageParams.page = 1; this.getList() },
    handlePageChange (page) { this.pageParams.page = page; this.getList() },
    handlePageSizeChange (size) { this.pageParams.limit = size; this.pageParams.page = 1; this.getList() },

    handleAdd () {
      this.modalTitle = '新增参数组'
      this.formData = { id: null, table: '', field: '', value: '', meaning: '', type: '', remark: '' }
      this.modalVisible = true
    },

    handleEdit (row) {
      this.modalTitle = '编辑参数组'
      this.formData = {
        id: row.id,
        table: row.table || '',
        field: row.field || '',
        value: row.value || '',
        meaning: row.meaning || '',
        type: row.type || '',
        remark: row.remark || ''
      }
      this.modalVisible = true
    },

    async handleSubmit () {
      this.$refs.mergeForm.validate(async (valid) => {
        if (valid) {
          const res = await saveParameterMerge({
            id: this.formData.id,
            table: this.formData.table,
            field: this.formData.field,
            value: this.formData.value,
            meaning: this.formData.meaning,
            type: this.formData.type,
            remark: this.formData.remark,
            child_ids: []
          })
          if (res.data.code === 0) {
            this.$Message.success(this.formData.id ? '更新成功' : '新增成功')
            this.modalVisible = false
            this.getList()
            this.loadAllGroups()
          } else {
            this.$Message.error(res.data.msg || '操作失败')
          }
        }
      })
    },

    handleDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定要删除该参数组吗？',
        onOk: async () => {
          try {
            const res = await deleteParameterMerge(row.id)
            if (res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getList()
              this.loadAllGroups()
            } else {
              this.$Message.error(res.data.msg || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败')
            console.error(error)
          }
        }
      })
    },

    // ========== 子类选择弹窗 ==========
    openChildSelectModal (row) {
      this.childSelectGroupId = row.id
      this.currentGroupTable = row.table
      this.currentGroupField = row.field
      this.currentChildIds = this.getChildIdsArray(row)
      this.childSearchKeyword = ''
      this.childPageParams = { page: 1, limit: 10 }
      this.childSelection = []
      this.childSelectModalVisible = true
      this.loadChildParams()
    },

    async loadChildParams () {
      this.childLoading = true
      try {
        // 按 table+field 筛选 sys_parameter
        const res = await getsysparameterList(
          this.currentGroupTable,
          this.currentGroupField,
          '',
          this.childPageParams.page,
          this.childPageParams.limit,
          ''
        )
        if (res.data.code === 0) {
          const list = res.data.data || []
          // 如果有关键词搜索，前端再过滤
          let filtered = list
          if (this.childSearchKeyword) {
            const kw = this.childSearchKeyword.toLowerCase()
            filtered = list.filter(item =>
              (item.meaning && item.meaning.toLowerCase().includes(kw)) ||
              (item.value && item.value.toLowerCase().includes(kw)) ||
              (item.remark && item.remark.toLowerCase().includes(kw))
            )
          }
          this.childTableData = filtered.map(item => ({
            ...item,
            _checked: this.currentChildIds.includes(item.id)
          }))
          this.childTotal = res.data.count || 0
          // 设置已选中的行
          this.$nextTick(() => {
            if (this.$refs.childTable) {
              this.childTableData.forEach(row => {
                if (row._checked) {
                  this.$refs.childTable.toggleSelect(row)
                }
              })
            }
          })
        }
      } catch (error) {
        console.error('加载参数列表失败', error)
      } finally {
        this.childLoading = false
      }
    },

    searchChildParams () {
      this.childPageParams.page = 1
      this.loadChildParams()
    },

    handleChildSelectionChange (selection) {
      this.childSelection = selection
      const selectedIds = selection.map(s => s.id)
      const currentPageIds = this.childTableData.map(d => d.id)
      const otherPageIds = this.currentChildIds.filter(id => !currentPageIds.includes(id))
      this.currentChildIds = [...new Set([...otherPageIds, ...selectedIds])]
    },

    handleChildPageChange (page) { this.childPageParams.page = page; this.loadChildParams() },
    handleChildPageSizeChange (size) { this.childPageParams.limit = size; this.childPageParams.page = 1; this.loadChildParams() },

    async saveChildSelection () {
      this.childSaving = true
      try {
        const res = await saveParameterMerge({
          id: this.childSelectGroupId,
          child_ids: this.currentChildIds
        })
        if (res.data.code === 0) {
          this.$Message.success('子类保存成功')
          this.childSelectModalVisible = false
          this.getList()
        } else {
          this.$Message.error(res.data.msg || '保存失败')
        }
      } catch (error) {
        this.$Message.error('保存失败')
        console.error(error)
      } finally {
        this.childSaving = false
      }
    },

    // ========== 已选子类列表弹窗 ==========
    openChildListModal (row) {
      console.log('openChildListModal called', row)
      this.childListGroupId = row.id
      this.childListSelection = []
      this.childListModalVisible = true
      this.loadChildList(row)
    },

    async loadChildList (row) {
      this.childListLoading = true
      try {
        const childIds = this.getChildIdsArray(row)
        if (childIds.length === 0) {
          this.childListData = []
          this.childListLoading = false
          return
        }
        // 按 table+field 加载所有参数，再过滤出子类
        const res = await getsysparameterList(row.table, row.field, '', 1, 9999, '')
        if (res.data.code === 0) {
          const all = res.data.data || []
          this.childListData = all.filter(item => childIds.includes(item.id))
        }
      } catch (error) {
        console.error('加载子类列表失败', error)
      } finally {
        this.childListLoading = false
      }
    },

    handleChildListSelectionChange (selection) { this.childListSelection = selection },

    async removeSingleChild (child) {
      const row = this.tableData.find(r => r.id === this.childListGroupId)
      if (!row) return
      const ids = this.getChildIdsArray(row).filter(id => id !== child.id)
      await this.updateChildren(ids)
    },

    async batchDeleteChildren () {
      if (this.childListSelection.length === 0) return
      const row = this.tableData.find(r => r.id === this.childListGroupId)
      if (!row) return
      const removeIds = this.childListSelection.map(s => s.id)
      const ids = this.getChildIdsArray(row).filter(id => !removeIds.includes(id))
      await this.updateChildren(ids)
    },

    async clearAllChildren () {
      this.$Modal.confirm({
        title: '确认清空',
        content: '确定要清空所有子类参数吗？',
        onOk: async () => {
          await this.updateChildren([])
        }
      })
    },

    async updateChildren (ids) {
      try {
        const res = await saveParameterMerge({
          id: this.childListGroupId,
          child_ids: ids
        })
        if (res.data.code === 0) {
          this.$Message.success('操作成功')
          this.getList()
          const row = this.tableData.find(r => r.id === this.childListGroupId)
          if (row) await this.loadChildList(row)
        } else {
          this.$Message.error(res.data.msg || '操作失败')
        }
      } catch (error) {
        this.$Message.error('操作失败')
        console.error(error)
      }
    },

    // ========== 数据参数更迭 ==========
    openIterateModal () {
      this.iterateFormData = { group_id: null }
      this.iterateModalVisible = true
    },

    async handleIterate () {
      this.$refs.iterateForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await iterateParameterMerge({
              group_id: this.iterateFormData.group_id
            })
            if (res.data.code === 0) {
              this.$Message.success(`数据参数更迭成功，共更新 ${res.data.count || 0} 条记录`)
              this.iterateModalVisible = false
              this.getList()
            } else {
              this.$Message.error(res.data.msg || '更迭失败')
            }
          } catch (error) {
            this.$Message.error('更迭失败')
            console.error(error)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.parameter-merge-container {
  padding: 10px;
}
.search-con {
  display: flex;
  align-items: center;
}
.child-select-bar {
  display: flex;
  align-items: center;
}
</style>